// extracted by mini-css-extract-plugin
module.exports = {"Paper":"ManageWeatherStationFieldConnections_Paper__2VNNL"};